import { render } from "./pairing_show_header.vue?vue&type=template&id=09189312&lang=pug"
import script from "./pairing_show_header.vue?vue&type=script&lang=js"
export * from "./pairing_show_header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__